import React, { useEffect, useState } from 'react';
import SelectBox from '../../shared/controls/form/selectBox';
import { TextBox } from '../../shared/controls/form';
import { Form, Formik } from 'formik';
import DateTimePicker from '../../shared/controls/form/dateTimePicker';
import { toast } from 'react-toastify';
import apiServices from '../../services/service';
import closeSqr from '../../../src/assets/img/crm_home/main-content/close-square.svg';
import info from '../../../src/assets/img/crm_home/main-content/info.png';
import { useSelector } from 'react-redux';
import { getGenericMasterFilteredListByKey, getZohoCampaigns } from '../../redux/selector';
import useFetchIfNeeded from '../../redux/useFetchIfNeeded';
import { fetchDataAndUpdateStore } from '../../redux/actions';
import { opportunityInputData } from '../../shared/constants';

const EmailSteps = ({ formData, errormsg }) => {
    const triggerOutreachOptions = useSelector(getGenericMasterFilteredListByKey("TriggerOutreach"))
    // const draftCampaignOptions = useSelector(getZohoCampaigns)
    //  console.log("🚀 ~ EmailSteps ~ draftCampaignOptions:", draftCampaignOptions)
//      useFetchIfNeeded(getZohoCampaigns, fetchDataAndUpdateStore, {
//     key: 'zohoCampaigns',
//     // inputData: opportunityInputData,
//   });
const [draftCampaignOptions, setDraftCampaignOptions] =useState();
const [refreshSteps, setRefreshSteps] = useState(false);


 // ✅ Autofill steps if formData has existing emailSequence
useEffect(() => {
  const fetchSequenceDetails = async () => {
    if (!formData?.id) return;

    try {
      // 🚀 Fetch the latest steps by Sequence ID
      const req = { id: formData.id };
      const seqResponse = await apiServices.getEmailSequencebySequenceId(req);
      if (seqResponse.status === 200 && seqResponse.data?.emailSequence?.steps?.length) {
        const updatedSteps = seqResponse.data.emailSequence.steps.map((step, index) => ({
          stepOrder: step.stepOrder || index + 1,
          stepName: step.stepName || `Step ${index + 1}`,
          triggerOutreach: step.triggerOutreach || '',
          sendTime: step.sendTime ? new Date(step.sendTime).toISOString() : null,
          draftCampaign: step.draftCampaign || '',
          delay: step.delay || '',
          excludeWeekendsAndHolidays:
            step.excludeWeekendsAndHolidays !== undefined
              ? step.excludeWeekendsAndHolidays
              : true,
          isStepEnabled: step.isStepEnabled !== undefined ? step.isStepEnabled : true,

          notificationId:
            step.notificationId &&
            step.notificationId !== 'string' &&
            step.notificationId.trim() !== ''
              ? step.notificationId
              : '',

          selectedOptions: {
            triggerOutreach: step.triggerOutreach ? { label: step.triggerOutreach } : null,
            draftCampaign: step.draftCampaign ? { label: step.draftCampaign } : null,
            days: step.delayUnit ? { label: step.delayUnit } : null,
          },
        }));

        setSteps(updatedSteps);
        console.log('✅ Steps updated from SmartSequenceGetSequenceDetailsById:', updatedSteps);
      } else {
        console.warn('⚠️ No updated steps found for this sequence.');
      }
    } catch (error) {
      console.error('❌ Error fetching sequence details:', error);
      toast.error('Failed to refresh sequence details.', { position: 'top-right' });
    }
  };

  // 🧠 If refreshSteps is TRUE → fetch from API (after save)
  // Else → bind normally from formData (first load from list)
  if (refreshSteps) {
    fetchSequenceDetails();
    setRefreshSteps(false); // reset flag
  } else if (formData?.emailSequence?.steps?.length) {
    // 🧩 First load: bind from existing formData
    const prefilledSteps = formData.emailSequence.steps.map((step, index) => ({
      stepOrder: step.stepOrder || index + 1,
      stepName: step.stepName || `Step ${index + 1}`,
      triggerOutreach: step.triggerOutreach || '',
      sendTime: step.sendTime ? new Date(step.sendTime).toISOString() : null,
      draftCampaign: step.draftCampaign || '',
      delay: step.delay || '',
      excludeWeekendsAndHolidays:
        step.excludeWeekendsAndHolidays !== undefined
          ? step.excludeWeekendsAndHolidays
          : true,
      isStepEnabled: step.isStepEnabled !== undefined ? step.isStepEnabled : true,

      notificationId:
        step.notificationId &&
        step.notificationId !== 'string' &&
        step.notificationId.trim() !== ''
          ? step.notificationId
          : '',

      selectedOptions: {
        triggerOutreach: step.triggerOutreach ? { label: step.triggerOutreach } : null,
        draftCampaign: step.draftCampaign ? { label: step.draftCampaign } : null,
        days: step.delayUnit ? { label: step.delayUnit } : null,
      },
    }));

    setSteps(prefilledSteps);
  }
}, [formData, refreshSteps]);




useEffect(() => {
  const fetchZohoCampaigns = async () => {
    try {
      const response = await apiServices.getZohoCampaigns();
      if (response.status === 200) {
        setDraftCampaignOptions(response.data)
      } else {
        console.warn("⚠️ Failed to fetch Zoho Campaigns:", response);
      }
    } catch (error) {
      console.error("❌ Error fetching Zoho Campaigns:", error);
    }
  };

  fetchZohoCampaigns();
}, []);
//   const triggerOutreachOptions = [
//     { id: 1, label: 'Lead Nurturing' },
//     { id: 2, label: 'Re-Engagement' },
//     { id: 3, label: 'Promotional' },
//     { id: 4, label: 'Event' },
//     { id: 5, label: 'Cold Outreach' },
//   ];

//   const draftCampaignOptions = [
//     { id: 1, label: 'Technology' },
//     { id: 2, label: 'Healthcare' },
//     { id: 3, label: 'Finance' },
//     { id: 4, label: 'Manufacturing' },
//   ];

  const days = [{ id: 1, label: 'Days' }];

  const [steps, setSteps] = useState([
    {
      stepOrder: 1,
      stepName: 'Initial Outreach',
      triggerOutreach: '',
      sendTime: null,
      draftCampaign: '',
      excludeWeekendsAndHolidays: true,
      isStepEnabled: true,
      notificationId: '',
      selectedOptions: {
        triggerOutreach: null,
        draftCampaign: null,
        days: null,
      },
      delay: '',
    },
  ]);

  const handleChange = (selectedOption, name, index) => {
    const updatedSteps = [...steps];
    updatedSteps[index].selectedOptions[name] = selectedOption;
    updatedSteps[index][name] = selectedOption?.label || '';
    setSteps(updatedSteps);
  };

// const handleDateTime = (date, index) => {
//   const dataTime = date.target.value;
//   const updatedSteps = [...steps];
//   updatedSteps[index].sendTime = dataTime; // stores raw string like '2025-10-08T14:00'
//   setSteps(updatedSteps);
// };

const handleDateTime = (date, index) => {
  const selectedTime = new Date(date.target.value);
  const now = new Date();

  // Minimum allowed time: 15 minutes from now
  const minTime = new Date(now.getTime() + 15 * 60 * 1000);

  // If selected time is before minimum, show error & prevent update
  if (selectedTime < minTime) {
    toast.error('Please select a time at least 15 minutes from now.', {
      position: 'top-right',
    });
    return; // Don't update state
  }

  const updatedSteps = [...steps];
  updatedSteps[index].sendTime = selectedTime.toISOString();
  setSteps(updatedSteps);
};


  const handleCheckboxChange = (e, index) => {
    const { name, checked } = e.target;
    const updatedSteps = [...steps];
    updatedSteps[index][name] = checked;
    setSteps(updatedSteps);
  };

  const handleStepNameChange = (e, index) => {
    const updatedSteps = [...steps];
    updatedSteps[index].stepName = e.target.value;
    setSteps(updatedSteps);
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const updatedSteps = [...steps];
    updatedSteps[index][name] = value;
    setSteps(updatedSteps);
  };

  const handleAddStep = () => {
    const newStep = {
      stepOrder: steps.length + 1,
      stepName: `Follow-up Email`,
      triggerOutreach: '',
      sendTime: null,
      draftCampaign: '',
      excludeWeekendsAndHolidays: true,
      isStepEnabled: true,
      notificationId: '',
      selectedOptions: {
        triggerOutreach: null,
        draftCampaign: null,
        days: null,
      },
      delay: '',
    };
    setSteps([...steps, newStep]);
  };

  const handleRemoveStep = (index) => {
    const updatedSteps = steps.filter((_, i) => i !== index);
    setSteps(updatedSteps.map((s, i) => ({ ...s, stepOrder: i + 1 })));
  };

 const handleSubmit = async () => {
  try {
    const payload = {
      id: formData?.id,
      emailSequence: {
        steps: steps.map((s) => ({
          stepOrder: s.stepOrder,
          stepName: s.stepName,
          triggerOutreach: s.triggerOutreach,
          delay: Number(s.delay) || 0,
          delayUnit: 'Days',
          sendTime: s.sendTime
            ? new Date(s.sendTime).toISOString()
            : new Date().toISOString(),
          draftCampaign: s.draftCampaign,
          excludeWeekendsAndHolidays: s.excludeWeekendsAndHolidays,
          isStepEnabled: s.isStepEnabled,
          notificationId:
            s.notificationId && s.notificationId.trim() !== ''
              ? s.notificationId
              : formData?.notificationId
              ? formData.notificationId
              : '',
        })),
      },
      sequenceOwner: formData?.sequenceOwner || 'string',
    };

    const response = await apiServices.smartSequenceEmailSteps(payload);

    if (response.status === 200 || response.data?.success) {
      toast.success('Email steps saved successfully!', { position: 'top-right' });
      setRefreshSteps(true); // ✅ trigger API call in useEffect
    } else {
      toast.error('Failed to save steps. Please try again.', { position: 'top-right' });
    }
  } catch (err) {
    console.error('❌ Error:', err);
    toast.error('An unexpected error occurred.', { position: 'top-right' });
  }
};




  return (
    <Formik initialValues={formData}>
      <Form>
        <div className="formBlock">
          <div className="frmHdr">
            <h2>Email Sequence Steps</h2>
          </div>

          {steps.map((step, index) => (
            <div
              className={`formContent pb-2 ${index > 0 ? 'pt-0' : ''}`}
              key={index}
            >
              <div className="emailStepHdr">
                <h3>
                  <span>{step.stepOrder}</span>{' '}
                  {index === 0 ? (
                    step.stepName
                  ) : (
                    <input
                      type="text"
                      value={step.stepName}
                      onChange={(e) => handleStepNameChange(e, index)}
                      placeholder="Enter Step Name"
                      style={{
                        border: 'none',
                        borderBottom: '1px solid #ccc',
                        background: 'transparent',
                        fontSize: '16px',
                        width: 'auto',
                        outline: 'none',
                      }}
                    />
                  )}
                </h3>

                <div className="rhtAct">
                  {index > 0 && (
                    <div className="dsk">
                      <div className="infoMsg pt-0 pe-2">
                        <img src={info} alt="" />
                        <p>Email won't be sent on weekends or holidays</p>
                      </div>
                    </div>
                  )}
                  {steps.length > 1 && (
                    <button
                      type="button"
                      className="btn imgBtn"
                      onClick={() => handleRemoveStep(index)}
                    >
                      <img src={closeSqr} alt="Delete Step" />
                    </button>
                  )}
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`enableStep-${index}`}
                      name="isStepEnabled"
                      checked={step.isStepEnabled}
                      onChange={(e) => handleCheckboxChange(e, index)}
                    />
                  </div>
                </div>
              </div>

              {index > 0 && (
                <div className="mob my-3">
                  <div className="infoMsg pt-0 pe-2">
                    <img src={info} alt="" />
                    <p>Email won't be sent on weekends or holidays</p>
                  </div>
                </div>
              )}

              <div className="emailBlk">
                <div className="row">
                  {/* Trigger Outreach */}
                  <div className="col-12 col-sm-6 col-md-3 col-lg-3">
                    <div className="input-container">
                      <SelectBox
                        label="Trigger Outreach"
                        name="triggerOutreach"
                        placeholder="Select Trigger Type"
                        selectedOptions={step.selectedOptions.triggerOutreach}
                        handleSelect={(option, name) => handleChange(option, name, index)}
                        options={triggerOutreachOptions}
                        optionKeys={['id', 'displayName']}
                        errormsg={errormsg?.triggerOutreach}
                      />
                    </div>
                  </div>

                  {/* Delay + Unit (only from 2nd step) */}
                  {index > 0 && (
                    <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                      <div className="input-container">
                        <div className="row">
                          <div className="col-12 col-sm-6 col-md-5">
                            <TextBox
                              isRequired={false}
                              label="Delay"
                              name="delay"
                              placeholder="Enter Delay"
                              value={step.delay}
                              handleChange={(e) => handleInputChange(e, index)}
                              maxLength={100}
                              errormsg={errormsg?.delay}
                            />
                          </div>
                          <div
                            className="col-12 col-sm-6 col-md-7"
                            style={{ paddingTop: '8px' }}
                          >
                            <SelectBox
                              label=" "
                              name="days"
                              placeholder="Select"
                              selectedOptions={step.selectedOptions.days}
                              handleSelect={(option, name) =>
                                handleChange(option, name, index)
                              }
                              options={days}
                              optionKeys={['id', 'label']}
                              errormsg={errormsg?.days}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Send Time */}
                  <div
                    className={`col-12 col-sm-6 col-md-${
                      index > 0 ? '2' : '3'
                    } col-lg-${index > 0 ? '2' : '3'}`}
                  >
                    <div className="input-container">
                      <label>Send Time</label>
                      <div className="dtBox">
                        <DateTimePicker
                          label="Send Time"
                          isRequired={true}
                          value={step.sendTime ? new Date(step.sendTime) : null}
                          onChange={(date) => handleDateTime(date, index)}
                          name="sendTime"
                          placeholder="Select Schedule date & time"
                          errormsg={errormsg?.sendTime}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Draft Campaign */}
                  <div
                    className={`col-12 col-sm-12 col-md-12 col-lg-${
                      index > 0 ? '3' : '5'
                    }`}
                  >
                    <div className="input-container">
                      <SelectBox
                        label="Draft Campaign"
                        name="draftCampaign"
                        placeholder="Select Draft Campaign"
                        selectedOptions={step.selectedOptions.draftCampaign}
                        handleSelect={(option, name) => handleChange(option, name, index)}
                        options={draftCampaignOptions}
                        optionKeys={['id', 'campaignName']}
                        errormsg={errormsg?.draftCampaign}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {/* Buttons */}
          <div className="formContent pt-0">
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={handleAddStep}
            >
              <i className="bi bi-plus-lg"></i> Add Step
            </button>

            <button
              type="button"
              className="btn btn-primary ms-2"
              onClick={handleSubmit}
            >
              Save Steps
            </button>
          </div>
        </div>
      </Form>
    </Formik>
  );
};

export default EmailSteps;
